//
import { required } from '@/services/validations'
import ProductModel from '@/models/Warehouse/WhProductToSearch'
import UserModel from '@/models/General/GUser'
import StockAdjustTypeModel from '@/models/Warehouse/WhStockAdjustType'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import ProductAdjustStockModel from '@/models/Warehouse/WhProductAdjustStock'
//
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '../create/headersProduct'

//
import StockAdjustDetailHeaders from './headers'

//
export default (
    wh_warehouse_id,
) => [
    {
        name: 'g_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin usuarios.',
            noObject: true,
            //readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_stock_adjust_type_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            itemText: 'type',
            itemValue: 'id',
            label: 'Tipo',
            model: StockAdjustTypeModel,
            noDataText: 'Sin tipos.',
            noObject: true,
            paramSearch: 'type',
            //readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            //readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_selected_products',
        type: 'table-field',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: StockAdjustDetailHeaders,
            noActions: true,
            noDataText: 'Sin productos.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            label: 'Items',
            pickerProps: {
                //filters: ProductFilters(),
                headers: ProductHeaders,
                noPagination: false,
                mapper: row => {
                    //row['g_branch_office_id'] = g_branch_office_id
                    row['quantity'] = 0
                    row['wh_product_id'] = row.id
                    return row
                },
                submitText: 'confirmar selección',
                service: ProductAdjustStockModel,
                attachParams: { wh_warehouse_id: wh_warehouse_id },
            },
            //readonly: true,
            rules: [required],
            showNativePagination: true,
            showPicker: false,
            style: {
                //margin: "0 -24px"
            },
            toolbarTitle: 'Lista de productos incluidos en el ajuste',
            toolbarColor: 'primary',
            toolbarDense: true,
            toolbarDark: true,
        },
    },
    {
        name: 'description',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Descripción',
            //readonly: true,
            rules: [required],
        },
    },
    {
        name: 'confirm_description',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Comentario de confirmacion',
            //readonly: true,
            rules: [required],
        },
    },
]
